import { render } from "./ComponentDiagram.vue?vue&type=template&id=14fa0de4"
import script from "./ComponentDiagram.vue?vue&type=script&lang=js"
export * from "./ComponentDiagram.vue?vue&type=script&lang=js"

import "./ComponentDiagram.vue?vue&type=style&index=0&id=14fa0de4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__